import { trackDigitalEvent } from '@sparknz/tracking';

import {
  DeviceOfferDetail,
  PaymentOption,
} from 'journey/productDetails/typings';
import { constructAnalyticsProduct } from 'journey/productDetails/utils/constructAnalyticsProduct';

export function trackExistingPlanSelector({
  numberOfEligiblePlansForIFP,
  device,
  paymentOption,
}: {
  numberOfEligiblePlansForIFP: number;
  device: DeviceOfferDetail;
  paymentOption: PaymentOption;
}) {
  trackDigitalEvent({
    event: 'shop.mobilePlanSelector.line.view',
    w3cddl: {
      event: [
        {
          eventInfo: {
            eventName: 'Mobile Plan Selector Line View',
            eventAction: 'shop.mobilePlanSelector.line.view',
          },
          attributes: {
            isSuccess: true,
            // @ts-ignore The following two attributes need to be added in EventAttribute type in tracking lib. Will remove comment once updated pattern lib.
            hasEligiblePlansForIFP: Boolean(numberOfEligiblePlansForIFP),
            numberOfEligiblePlansForIFP,
          },
        },
      ],
      product: [constructAnalyticsProduct({ device, paymentOption })],
    },
  });
}
